import React from "react";
import PropTypes from "prop-types";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector from "@mui/material/StepConnector";

export const stepperThemeProps = {
  barStyle: "none",
  circleFontSize: 12,
  activeColor: "var(--primary-icon-color)",
  defaultColor: "var(--secondary-color)",
  completeColor: "var(--primary-icon-color)",
  circleFontColor: "var(--secondary-font-color)",
  completeOpacity: ".5",
  activeTitleColor: "var(--primary-font-color)",
  completeTitleColor: "var(--primary-font-color)",
  defaultTitleColor: "var(--secondary-color)",
};

const MStepper = props => {
  const {
    steps,
    activeStep,
    connector,
    iconComponent,
    alternativeLabel,
    customClass,
  } = props;

  return (
    <div className={`${customClass}`}>
      <Stepper alternativeLabel={alternativeLabel} activeStep={activeStep} connector={connector}>
        {steps.map(label => (
          <Step key={label}>
            <StepLabel slots={{ stepIcon: iconComponent }}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

MStepper.defaultProps = {
  connector: (<StepConnector />),
  iconComponent: null,
  alternativeLabel: true,
};

MStepper.propTypes = {
  steps: PropTypes.array.isRequired, // array of strings to be used as steps
  activeStep: PropTypes.number.isRequired, // integer for the zero-based index of the active step from steps prop
  connector: PropTypes.object, // Allows for specifying a custom connector component
  iconComponent: PropTypes.func, // Allows for specifying a custom icon component
  alternativeLabel: PropTypes.bool, // Indicates whether or not labels should be aligned next to or underneath the icon (true == underneath)
  customClass: PropTypes.string, // Any custom class to be applied
};

export default MStepper;
